import Vue from "vue";
import VueI18n from "vue-i18n";
import Axios from "axios";

/// Bind i18n to Vue.
let i18n;
Object.defineProperty(Vue.prototype, "$i18n", {
  get() {
    return i18n;
  },
});

Vue.use(VueI18n);

// Create VueI18n instance with options
const locale = document.documentElement.lang;
i18n = new VueI18n({
  locale: locale,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  messages: {
    [locale]: window.STRINGS,
  },
});

// Tweak for using keys as default translations.
// Fixes the problem the key is missed in translations
// and arguments are not interpolated
let _getPathValue = i18n._path.getPathValue;
i18n._path.getPathValue = function (obj, path) {
  let paths = i18n._path.parsePath(path);
  let ret;

  if (paths.length === 0) {
    ret = obj[path] || null;
  } else {
    ret = _getPathValue.call(this, obj, path);
  }

  return ret === null ? path : ret;
};

// Add current locale header to all requests
Axios.defaults.headers.common["X-Locale"] = locale;
